import {alias, createModelSchema} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";

export class PackageBackendDeployedModel extends BaseObject {

    constructor() {
        super();
        this._id = null;
        this._owner = null;
        this._version = null;
        this._name = null;
        this._checksum = null;
        this._created = null;
        this._size = null;
        this._type = null;
        this._updated = null;
        this._minver = null;
        this._maxver = null;
        this._aud = null;
    }

    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }

    get owner() {
        return this._owner;
    }
    set owner(value) {
        this._owner = value;
    }

    get version() {
        return this._version;
    }
    set version(value) {
        this._version = value;
    }

    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }

    get checksum() {
        return this._checksum;
    }
    set checksum(value) {
        this._checksum = value;
    }

    get created() {
        return this._created;
    }
    set created(value) {
        this._created = value;
    }

    get size() {
        return this._size;
    }
    set size(value) {
        this._size = value;
    }

    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value;
    }

    get updated() {
        return this._updated;
    }
    set updated(value) {
        this._updated = value;
    }

    get maxver() {
        return this._maxver;
    }
    set maxver(value) {
        this._maxver = value;
    }

    get minver() {
        return this._minver;
    }
    set minver(value) {
        this._minver = value;
    }

    get aud() {
        return this._aud;
    }
    set aud(value) {
        this._aud = value;
    }

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new PackageBackendDeployedModel());
        } else if (target instanceof PackageBackendDeployedModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(PackageBackendDeployedModel, {
    _id: alias("id", Schema.primitive()),
    _owner: alias("owner", Schema.primitive()),
    _version: alias("version", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _checksum: alias("checksum", Schema.primitive()),
    _created: alias("created", Schema.primitive()),
    _size: alias("size", Schema.primitive()),
    _type: alias("type", Schema.primitive()),
    _updated: alias("updated", Schema.primitive()),
    _minver: alias("minver", Schema.primitive()),
    _maxver: alias("maxver", Schema.primitive()),
    _aud: alias("aud", Schema.primitive()),
});